import React from "react"
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import swaggerspec from './swagger.json'

const HorizonSpec = () => <SwaggerUI 
                      spec={JSON.stringify(swaggerspec)} 
                      docExpansion="list" />

export default HorizonSpec;